import { Component, effect, inject, untracked } from '@angular/core';
import { StateService } from '@uirouter/core';

import { AnalyticsFactory } from 'src/app/ajs-upgraded-providers';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { PastDueInvoiceService } from 'src/app/billing/services/past-due-invoice.service';

/**
 * Shows a banner at the top of the app when the user's top-level company has
 * a past-due invoice.
 */
@Component({
  selector: 'past-due-banner',
  imports: [],
  templateUrl: './past-due-banner.component.html',
  styleUrl: './past-due-banner.component.scss',
  standalone: true,
})
export class PastDueBannerComponent {
  protected readonly pastDueInvoiceService = inject(PastDueInvoiceService);
  private readonly stateService = inject(StateService);
  private readonly companyStateService = inject(CompanyStateService);
  private readonly analyticsFactory = inject(AnalyticsFactory);

  private wasShown = false;

  constructor() {
    // Fire "Unpaid Invoice Banner Shown" once per false -> true transition,
    // not on every re-render while it stays visible.
    effect(() => {
      const hasPastDueInvoice = this.pastDueInvoiceService.hasPastDueInvoice();

      if (hasPastDueInvoice && !this.wasShown) {
        this.wasShown = true;
        untracked(() => {
          this.analyticsFactory.track('Unpaid Invoice Banner Shown', {
            companyId: this.companyStateService.getUserCompanyId(),
          });
        });
      } else if (!hasPastDueInvoice) {
        this.wasShown = false;
      }
    });
  }

  protected billingHref(): string {
    return this.stateService.href('apps.settings.billing.home', {
      cid: this.companyStateService.getUserCompanyId(),
    });
  }

  protected onPayNowClick(): void {
    this.analyticsFactory.track('Unpaid Invoice CTA Clicked', {
      companyId: this.companyStateService.getUserCompanyId(),
    });
  }
}
